module.exports = __webpack_public_path__ + "plane-pc/img/top_bj.315aa91d.png";